export const SEARCH_OPTION_POI_STORE_KEY = 'searchOptionSelectedPOI';
